import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import meterElec from '@/shared/components/SDComponentsNewDesign/meter_elec.svg'
import meterGas from '@/shared/components/SDComponentsNewDesign/meter_gas.svg'
import { useTranslation } from 'react-i18next'
import ElectricityMeter from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/ElectricityMeter'
import GasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/GasMeter'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import MeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/MeterInput'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { SECOND_ELECTRICITY_METER_KEY } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { ClientTabColumn } from '../styled-components'

const MeterIds = () => {
  const { t } = useTranslation()
  const { shouldShowMeterInformation, addressLabel } = useAddress()
  const { country } = useSelector(selectAuthData)
  const showSecondMeter = modulesConfig[country]?.meter?.secondMeter ?? false
  const isPulse = usePulseScope()

  if (!shouldShowMeterInformation) {
    return (
      <ClientTabColumn $pulse={isPulse}>
        <PanelNew
          alt={t('subscriptionForm:pdl_module.title')}
          title={t('subscriptionForm:pdl_module.title')}
          logo={meterElec}
          id='meter-id-address-missing'
        >
          {t('subscriptionForm:pdl_module.warning_address_needed')}
        </PanelNew>
        <PanelNew
          alt={t('subscriptionForm:pce_module.title')}
          title={t('subscriptionForm:pce_module.title')}
          logo={meterGas}
          id='GasMeter'
        >
          {t('subscriptionForm:pce_module.warning_address_needed')}
        </PanelNew>
      </ClientTabColumn>
    )
  }
  return (
    <ClientTabColumn $pulse={isPulse}>
      <PanelNew
        alt={t('subscriptionForm:pdl_module.title')}
        title={t('subscriptionForm:pdl_module.title')}
        subHeaderContent={addressLabel}
        logo={meterElec}
        id='ElectricityMeter'
      >
        <ElectricityMeter />
      </PanelNew>

      <PanelNew
        empty={!showSecondMeter}
        alt={t('subscriptionForm:pdl_module.title_second')}
        title={t('subscriptionForm:pdl_module.title_second')}
        subHeaderContent={addressLabel}
        logo={meterElec}
        id='SecondElectricityMeter'
      >
        <MeterInput meterKey={SECOND_ELECTRICITY_METER_KEY} />
      </PanelNew>

      <PanelNew
        alt={t('subscriptionForm:pce_module.title')}
        title={t('subscriptionForm:pce_module.title')}
        logo={meterGas}
        subHeaderContent={addressLabel}
        id='GasMeter'
      >
        <GasMeter />
      </PanelNew>
    </ClientTabColumn>
  )
}

export default MeterIds
